// SPDX-License-Identifier: AGPL-3.0-or-later

import {
	UNFOCUSED_FULLY_INTERACTIVE_CLASS,
	WINDOW_FOCUSED_CLASS,
} from '@app/features/ui/utils/WindowFocusInteractionGuard';

/**
 * Whether overlay animation is currently running.
 *
 * `App.module.css` pauses every animation inside the overlay scope while the window is neither
 * focused nor explicitly "unfocused but fully interactive". An effect started in that state would
 * sit frozen on its first keyframe, so timed effects check this before spawning rather than
 * burning a cooldown on something nobody can see.
 */
export function holidayOverlayAnimationsRun(root: HTMLElement | null = null): boolean {
	if (typeof document === 'undefined') return true;
	const element = root ?? document.documentElement;
	return (
		element.classList.contains(WINDOW_FOCUSED_CLASS) || element.classList.contains(UNFOCUSED_FULLY_INTERACTIVE_CLASS)
	);
}
